/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchTransactionListSwipeAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchTxnSwipe = createAsyncThunk('get/txnListSwipe', FetchTransactionListSwipeAPI);

export const FetchSwipeTxnSlice = createSlice({
	name: 'fetchTxnSwipe',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchTxnSwipe.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchTxnSwipe.rejected.toString()]: setAPIError,
		[fetchTxnSwipe.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchSwipeTxnSlice.name]: ReturnType<typeof FetchSwipeTxnSlice.reducer>;
}

export const fetchTxnSelector = (state: IStates): any => {
	return state[FetchSwipeTxnSlice.name] || {};
};

export const useSwipeTxnList = (): any => useSelector(fetchTxnSelector);

export const getSwipeTxnList =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchTxnSwipe(params));
		return;
	};

export const resetSwipeTxnList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchSwipeTxnSlice.actions.RESET());
		return;
	};
